/**
 * tracking is based on this concept https://elbkapitaene.atlassian.net/wiki/spaces/DT2019/pages/290258966/Modelfinder+-+Tracking+DT+Swiss
 */

import { sendTracking } from './../../js/tracking';

class ModelFinderTracking {
    constructor ($modelFinder) {
        this.$modelFinder = $modelFinder;
        this.$recentStep = undefined;
        this.trackingCategory = 'model-finder';
    }

    // tracking number in confluence: 1
    trackLoadedStep ($step) {
        if ($step) {
            const stepName = $step.getAttribute('data-tracking-name');
            const stepNumber = $step.getAttribute('data-step-number');

            sendTracking({
                category: this.trackingCategory,
                action: 'load',
                label: `filter_${stepName}_${stepNumber}`
            });
        }
    }

    // tracking number in confluence: 3, 4, 4.1
    trackStep ($step) {
        const stepName = $step.getAttribute('data-tracking-name');
        const stepNumber = $step.getAttribute('data-step-number');

        if ($step.classList.contains('model-finder__step--filled')) {
            // check if clicked step is the most recent clickable step
            if ($step === this.$recentStep) {
                sendTracking({
                    category: this.trackingCategory,
                    action: 'click',
                    label: `filter_${stepName}_${stepNumber}_forth`
                });
            } else {
                sendTracking({
                    category: this.trackingCategory,
                    action: 'click',
                    label: `filter_${stepName}_${stepNumber}_back`
                });
            }
        } else if ($step.classList.contains('model-finder__step--disabled')) {
            sendTracking({
                category: this.trackingCategory,
                action: 'click',
                label: `filter_${stepName}_${stepNumber}_next_noclickpossible`
            });
        }
    }

    // tracking number in confluence: 2
    trackOption ($step) {
        const stepName = $step.getAttribute('data-tracking-name');
        const stepNumber = $step.getAttribute('data-step-number');
        const $radioName = $step.querySelector('[data-model-finder="radio"]:checked').value;

        sendTracking({
            category: this.trackingCategory,
            action: 'click',
            label: `filter_${stepName}_${stepNumber}_${$radioName}`
        });
    }

    // tracking number in confluence: 5, 6
    trackOverlayToggle () {
        const isOverlayActive = this.$modelFinder.classList.contains('model-finder--active');
        const $steps = this.$modelFinder.querySelectorAll('.model-finder__step:not(.model-finder__step--disabled)');
        const $disabledSteps = this.$modelFinder.querySelectorAll('.model-finder__step--disabled');
        let $latestStep;

        // take the last step with a selected option, but if there is no disabled step
        // it means the latest step with selected option is the last step in the complete
        // step list
        if ($disabledSteps.length > 0) {
            $latestStep = $steps[$steps.length - 2];
        } else {
            $latestStep = $steps[$steps.length - 1];
        }

        let stepName = '';
        let stepNumber = '';
        if ($latestStep) {
            stepName = $latestStep.getAttribute('data-tracking-name');
            stepNumber = $latestStep.getAttribute('data-step-number');
        } else {
            stepName = 'not-selected';
            stepNumber = 0;
        }

        // overlay is currently open and user intends to close it
        if (isOverlayActive) {
            sendTracking({
                category: this.trackingCategory,
                action: 'click',
                label: `result_hide_filter_${stepName}_${stepNumber}`
            });
        } else { // overlay is currently closed and user intends to open it
            sendTracking({
                category: this.trackingCategory,
                action: 'click',
                label: `result_show_filter_${stepName}_${stepNumber}`
            });
        }
    }

    /**
     *
     * @param {integer} direction: -1 = back, 1 = next
     *
     * tracking number in confluence: 7, 8
     */
    trackSliding (direction) {
        const visibleSlides = this.getVisibleSlide();
        const numSlides = this.$modelFinder.querySelectorAll('.model-finder__slide').length;

        if (direction === -1) {
            sendTracking({
                category: this.trackingCategory,
                action: 'swipe',
                label: `result_back_[${visibleSlides}]_${numSlides}`
            });
        } else if (direction === 1) {
            sendTracking({
                category: this.trackingCategory,
                action: 'swipe',
                label: `result_forth_[${visibleSlides}]_${numSlides}`
            });
        }
    }

    // tracking number in confluence: 9
    trackFinish () {
        const $steps = this.$modelFinder.querySelectorAll('.model-finder__step');
        const $lastStep = $steps[$steps.length - 1];
        const stepName = $lastStep.getAttribute('data-tracking-name');
        const stepNumber = $lastStep.getAttribute('data-step-number');

        sendTracking({
            category: this.trackingCategory,
            action: 'finished',
            label: `result_filter_${stepName}_${stepNumber}`
        });
    }

    // tracking number in confluence: 10
    trackReset () {
        sendTracking({
            category: this.trackingCategory,
            action: 'click',
            label: 'result_reset'
        });
    }

    getVisibleSlide () {
        const $slides = this.$modelFinder.querySelectorAll('.model-finder__slide');
        let outputString = '';

        for (let i = 0; i < $slides.length; i++) {
            const $slide = $slides[i];

            if ($slide.classList.contains('swiper-slide-visible')) {
                outputString = outputString + (i + 1) + '-';
            }

            if (i === $slides.length - 1) {
                outputString = outputString.slice(0, -1);
            }
        }

        return outputString;
    }
}

export { ModelFinderTracking };
